import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServiceResponseModule } from '@sdbn/common';
import { YardAdministrationComponent } from './component/yard-administration.component';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { TmcYardCommonModule } from '../../../common/common.module';
import { CommonTranslationModule } from '@sdbn/common';
import { TransportOptionsPanelModule } from '../../../components/transport-options-panel/transport-options-panel.module';
import { TileButtonModule } from '@sdbn/tmc-common';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    ApplicationClientCommonModule,
    TmcYardCommonModule,
    CommonTranslationModule,
    ServiceResponseModule,
    TransportOptionsPanelModule,
    TileButtonModule
  ],
  declarations: [
    YardAdministrationComponent
  ]
})
export class YardAdministrationModule { }
